import axios from 'axios';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import IResponse from '../../interfaces/response';
import CarType from '../../interfaces/car';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers';
export default function DateSearch() {
	const { setCars, page, setPage, setLoading, setTotalPage } = useOutletContext<{
		setCars: Dispatch<SetStateAction<CarType[]>>,
		page: number,
		setPage: Dispatch<SetStateAction<number>>,
		setLoading: Dispatch<SetStateAction<boolean>>,
		setTotalPage: Dispatch<SetStateAction<number>>,
	}>();
	const { t } = useTranslation();
	const [toDate, setToDate] = useState<Date | null>(new Date);
	const [fromDate, setFromDate] = useState<Date | null>(null);

	useEffect(() => {
		setLoading(true);
		axios<IResponse<CarType[]>>({
			url: '/car',
			params: {
				page,
				register_date_from: fromDate?.toISOString().slice(0, 10),
				register_date_to: toDate?.toISOString().slice(0, 10),
			}
		}).then(res => {
			if (res.data.success) {
				setCars(res.data.data)
				setTotalPage(res.data.pagination?.totalPages ?? 0)
			}
		}).finally(() => {
			setLoading(false);
		})
	}, [toDate, fromDate, page])

	const handleChangeToDate = (value: Date | null) => {
		setToDate(value);
		setPage(1); // reset page to 1 when toDate changes to avoid getting incorrect results for the next page.
	}

	const handleChangeFromDate = (value: Date | null) => {
		setFromDate(value);
		setPage(1); // reset page to 1 when fromDate changes to avoid getting incorrect results for the next page.
	}
	return (
		<div className='flex flex-row gap-4 w-full mb-9 bg-primary-hover rounded-lg p-8'>
			<DatePicker value={fromDate} onChange={handleChangeFromDate} label={t('from_date')} />
			<DatePicker value={toDate} onChange={handleChangeToDate} label={t('to_date')} />
		</div>
	)
}
